import { type UUID } from '~/types/common';

/**
 * Query key factory for data export-related queries.
 */
export const queryKeysDataExport = {
  base: () => 'dataExports' as const,
  getResult: (jobId: UUID, requestId?: string) =>
    [queryKeysDataExport.base(), 'result', { jobId, requestId }] as const,
} as const;
